import React from 'react';

const ExpandMoreArrowUp = () => {
  return (
    <div className="expand-up-arrow">
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.41 7.70496L6 3.12496L10.59 7.70496L12 6.29496L6 0.294956L1.23266e-07 6.29496L1.41 7.70496Z" fill="#101316" />
      </svg>
    </div>
  );
};

export default ExpandMoreArrowUp;
